'use client';

import { useEffect } from 'react';

export function MSWProvider() {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      const initMocks = async () => {
        const { initializeMSW } = await import('@/mock/initialize');
        await initializeMSW();
      };
      initMocks();
    }
  }, []);

  return null;
}
